import React, { useState, useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import playImg from '../../../images/aiReport/play.png';
import pauseImg from '../../../images/aiReport/pause.png';
import playingIcon from '../../../images/aiReport/playing-icon.png';

const ResultApp = ({data = {}, closeVideo}, ref) => {
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [voiceList, setVoiceList] = useState([]);

    useImperativeHandle(ref, () => ({
        closeAudio: ()=> {
            audioRef.current && audioRef.current.pause();
            setIsPlaying(false);
        }
    }))

    useEffect(()=>{
        let _list = [];
        if(data.audioUrl){
            _list.push({
                type: 1,
                typeName: '普通话水平',
                voiceUrl: data.audioUrl,
                voiceTime: `${data.duration}s`,
                accuracy: data.pronAccuracy || 0,
                fluency: data.pronFluency || 0,
                integrity: data.pronCompletion || 0,
                statusName: data.chineseLevel || '',
                statusContent: data.chineseLevelDesc || '',
                statusClass: filterClass(data.chineseLevel),
            })
        }
        if(data.english){
            let english = data.english || {};
            _list.push({
                type: 2,
                typeName: '英语水平',
                voiceUrl: english.audioUrl,
                voiceTime: `${english.duration}s`,
                accuracy: english.pronAccuracy || 0,
                fluency: english.pronFluency || 0,
                integrity: english.pronCompletion || 0,
                statusName: english.enLevel || '',
                statusContent: english.enLevelDesc || '',
                statusClass: filterClass(english.enLevel),
            })
        }
        setVoiceList(_list);
    },[data])

    const filterClass = (level) => {
        switch (level) {
            case '好':
                return 'c52C41B' ;
            case '一般':
                return 'fdae21';
            case '不标准':
                return 'ff4d4f';
            default:
                return '';
        }
    };

    const changeAudio = ()=> {
        if(audioRef.current){
            isPlaying
                ? audioRef.current.pause()
                : audioRef.current.play().catch(() => setIsPlaying(false))

            // 改变isPlaying的状态
            setIsPlaying(!isPlaying)
        }
        closeVideo();
    };

    if(voiceList && voiceList.length){
        return (
            <div className="voice-wrap">
                <div className="readingTitleWrap">
                    <div className="readingTitleLeft">
                        <div className="readingTitleLeftIcon">
                            <span></span>
                            <span></span>
                        </div>
                        <span>语音分析</span>
                        <div className="readingTitleTab active1">
                            <i></i>
                            <p>准确度</p>
                        </div>
                        <div className="readingTitleTab active">
                            <i></i>
                            <p>流利度</p>
                        </div>
                        <div className="readingTitleTab">
                            <i></i>
                            <p>完整度</p>
                        </div>
                    </div>
                    <div className="readingTitleRight">

                    </div>
                </div>
                {/*内容部分*/}
                <div className="result-padding">
                    {
                        voiceList.map((item, key) => {
                            return (
                                <div className="voice-item" key={key}>
                                    <div className="voice-item-left">
                                        <div className="voice-item-typeName">
                                            <span>{item.typeName}</span>
                                            {item.voiceUrl && <div className="voice-item-url-wrap">
                                                <img src={isPlaying ? pauseImg : playImg} className="voice-item-play" onClick={changeAudio}/>
                                                <img src={playingIcon} className="voice-item-playing"/>
                                                <div className="voice-item-play-time">{item.voiceTime}</div>
                                            </div>}
                                        </div>
                                        <div className="voice-item-progress first">
                                            <div className="voice-item-progress-li">
                                                <p></p>
                                                <p style={{width: 310*(item.accuracy/10) >= 310 ? 310 : 310*(item.accuracy/10)}}></p>
                                            </div>
                                            <span className="voice-item-fluency">{item.accuracy}分</span>
                                        </div>
                                        <div className="voice-item-progress two">
                                            <div className="voice-item-progress-li">
                                                <p></p>
                                                <p style={{width: 310*(item.fluency/10) >= 310 ? 310 : 310*(item.fluency/10)}}></p>
                                            </div>
                                            <span className="voice-item-fluency">{item.fluency}分</span>
                                        </div>
                                        <div className="voice-item-progress three">
                                            <div className="voice-item-progress-li">
                                                <p></p>
                                                <p style={{width: 310*(item.integrity/10) >= 310 ? 310 : 310*(item.integrity/10)}}></p>
                                            </div>
                                            <span className="voice-item-fluency">{item.integrity}分</span>
                                        </div>
                                    </div>
                                    <div className="voice-item-right">
                                        <p className={item.statusClass}>{item.statusName}</p>
                                        <p>{item.statusContent}</p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>

                <div className="voice_audio">
                    <audio ref={audioRef} src={data.audioUrl} controls>
                        您的浏览器不支持 audio 标签。
                    </audio>
                </div>

            </div>
        );
    }else{
        return null;
    }
}

export default forwardRef(ResultApp);
